import { FunctionComponent } from "react";
import { faSparkles, faCoins, faGear } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { Tooltip } from "@/components/Tooltip/Tooltip";
import { classNames } from "@/utils/classNames";

interface AiSourceCellProps {
	label: string;
	placeholder?: string;
	onConfigure?: () => void;
	configureDisabled?: boolean;
	configureLabel: string;
	badgeLabel: string;
	creditTooltip: string;
	testIdPrefix: string;
}

export const AiSourceCell: FunctionComponent<AiSourceCellProps> = ({
	label,
	placeholder,
	onConfigure,
	configureDisabled = false,
	configureLabel,
	badgeLabel,
	creditTooltip,
	testIdPrefix,
}) => {
	const showPlaceholder = !label && Boolean(placeholder);

	return (
		<div
			className="flex items-center gap-2 py-[9px] px-3 rounded-xl border border-border-light bg-brand-white text-ssm"
			data-testid={`${testIdPrefix}-ai-source-cell`}
		>
			<span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-purple-100 text-purple-800 text-[10px] font-semibold uppercase tracking-wide flex-shrink-0">
				<Icon className="w-2.5 h-2.5" icon={faSparkles} />
				{badgeLabel}
			</span>
			<span
				className={classNames(
					"flex-1 truncate",
					showPlaceholder ? "italic text-text-disabled" : "text-text"
				)}
				data-testid={`${testIdPrefix}-ai-source-label`}
			>
				{showPlaceholder ? placeholder : label}
			</span>
			<button
				className={classNames(
					"inline-flex items-center gap-1 px-2 py-1 rounded-md border border-border-light text-xs text-text-meta",
					configureDisabled
						? "opacity-50 cursor-not-allowed"
						: "hover:text-text hover:border-text-meta cursor-pointer"
				)}
				data-testid={`${testIdPrefix}-ai-configure-button`}
				disabled={configureDisabled}
				type="button"
				onClick={() => !configureDisabled && onConfigure?.()}
			>
				<Icon className="w-3 h-3" icon={faGear} />
				{configureLabel}
			</button>
			<Tooltip content={creditTooltip}>
				<span
					className="w-5 h-5 rounded bg-brand-white border border-border-light flex items-center justify-center text-text-meta"
					data-testid={`${testIdPrefix}-ai-credit-icon`}
				>
					<Icon className="w-3 h-3" icon={faCoins} />
				</span>
			</Tooltip>
		</div>
	);
};
